<div class="rt-global-search-backdrop" [class.show]="show()" (click)="hide()" (keypress)="$event.stopPropagation()" tabindex="1000">
  <div class="rt-global-search" [class.empty]="empty()" (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()" tabindex="0">
    <div class="rt-global-search-inner">
      <form class="rt-global-search-input" [formGroup]="searchForm">
        <input
          formControlName="term"
          type="text" 
          placeholder="Type to search..." 
          [cdkTrapFocusAutoCapture]="show()" 
          [cdkTrapFocus]="show()"
        />  
        <p-button
          icon="pi pi-search"
          [rounded]="true"
          [routerLink]="['/search']"
          (onClick)="hide()"
        />
      </form>
      <div class="rt-global-search-content">
        @if (suggestions().length > 0) {
          <div class="rt-global-search-suggestions">
            <h5>Suggestions</h5>
            <div>
              
            </div>
          </div>            
        }
        @if (organizations().length > 0) {
          <div class="rt-global-search-suggestions">
            <h5>Profiles</h5>
            <div>
              @for (organization of organizations(); track $index) {
                <a class="rt-global-search-suggestion" (click)="selectOrganization(organization)" (keypress.space)="selectOrganization(organization)" [tabindex]="$index">
                  <p-avatar 
                    [image]="organization.image_url"
                    [label]="!organization.image_url ? organization.name.charAt(0) : ''"
                    shape="circle"
                  />
                  <span>{{ organization.name }}</span>
                </a>
              }
            </div>
          </div>            
        }
        @if (categories().length > 0) {
          <div class="rt-global-search-suggestions">
            <h5>Categories</h5>
            <div>
              @for (category of categories(); track $index) {
                <a class="rt-global-search-suggestion" (click)="selectCategory(category)" (keypress.space)="selectCategory(category)" [tabindex]="$index">
                  <p-avatar 
                    [label]="category.name.charAt(0)"
                    shape="circle"
                  />
                  <span>{{ category.name }}</span>
                </a>
              }
            </div>
          </div>            
        }
      </div>
    </div>

  </div>
</div>  